export default __webpack_public_path__ + "static/jbhifi-188cb3ceb13cff80307cbcd882bebcb6.png";